export enum ProductCode {
  HOHHInsurance = 'CFH',
  HOHHTakaful = 'TFH',
  MyRumahInsurance = 'CFZ',
  MyRumahTakaful = 'TFZ',
}
